import { render, staticRenderFns } from "./dialogUpdateNotice.vue?vue&type=template&id=09b0e934&scoped=true"
import script from "./dialogUpdateNotice.vue?vue&type=script&lang=js"
export * from "./dialogUpdateNotice.vue?vue&type=script&lang=js"
import style0 from "./dialogUpdateNotice.vue?vue&type=style&index=0&id=09b0e934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b0e934",
  null
  
)

export default component.exports